export const ProtectedTagSettingKey = 'tools.ozone.setting.protectedTags'
export const PolicyListSettingKey = 'tools.ozone.setting.policyList'
export const SeverityLevelSettingKey = 'tools.ozone.setting.severityLevels'
